






import { useEffect, useState } from "react";
import {
  addOfficeWalletApi,
  getOfficeWalletHistoryApi,
  getOfficeExpenseSummaryApi,
  deleteOfficeWalletApi,
} from "../../app/api";
import { createPortal } from "react-dom";
import {
  Wallet as WalletIcon,
  TrendingUp,
  TrendingDown,
  PieChart,
  PlusCircle,
  History,
  Trash2,
  IndianRupee,
  StickyNote,
  RotateCcw,
  Plus,
  X,
  CreditCard,
  ChevronRight,
  ChevronLeft,
  ShieldCheck,
  Zap
} from "lucide-react";
 
const PAGE_SIZE = 10;
export default function Wallet() {

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState("");



  const [modal, setModal] = useState({
    show: false,
    type: "", // "success" | "error"
    message: "",
  });
  const [history, setHistory] = useState([]);
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
 
  const [confirmDelete, setConfirmDelete] = useState({
    show: false,
    id: null,
  });
 
  useEffect(() => {
    loadWalletData();
  }, []);
 
  const loadWalletData = async () => {
    setIsLoading(true);
    const r1 = await getOfficeWalletHistoryApi();
    if (r1.success) setHistory(r1.data || []);
 
    const r2 = await getOfficeExpenseSummaryApi();
    if (r2.success) setSummary(r2.data || null);
    setIsLoading(false);
  };
 
  // const handleAddAmount = async () => {
  //   if (!amount) return alert("Enter amount");
  //   const res = await addOfficeWalletApi({ amount: Number(amount), remarks });
  //   if (res.success) {
  //     setAmount("");
  //     setRemarks("");
  //     loadWalletData();
  //   } else {
  //     alert("Failed to update liquidity");
  //   }
  // };
 
  const handleDeleteWallet = async () => {
    const id = confirmDelete.id;
    setConfirmDelete({ show: false, id: null });
    const res = await deleteOfficeWalletApi(id);
    if (res.success) loadWalletData();
  };
 
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };






  const handleAddAmount = async () => {
    if (!amount) {
      setModal({
        show: true,
        type: "error",
        message: "Please enter amount",
      });
      return;
    }
  
    try {
      setIsSubmitting(true);
  
      const res = await addOfficeWalletApi({
        amount: Number(amount),
        remarks,
      });
  
      if (res.success) {
        setAmount("");
        setRemarks("");
        loadWalletData();
  
        setModal({
          show: true,
          type: "success",
          message: "Amount added successfully ✅",
        });
      } else {
        setModal({
          show: true,
          type: "error",
          message: res.message || "Failed to update wallet ❌",
        });
      }
    } catch (error) {
      setModal({
        show: true,
        type: "error",
        message: "Something went wrong ❌",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    // <div className="max-w-6xl mx-auto md:mt-10 px-4 mb-20">
    <div className="max-w-8xl mx-auto md:mt-20 md:mb-20 ">
    <div className="
      relative overflow-hidden
      rounded-[20px] p-8 md:p-12
      bg-gradient-to-br from-[#1e174a] to-[#0f0c29]/95
      backdrop-blur-2xl text-white
      border border-white/10
      shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
    ">
      {/* HEADER */}
      <div className="flex items-center gap-4 mb-10 text-white">
        <div className="p-3.5 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 shadow-xl shadow-emerald-500/20">
          <WalletIcon className="w-8 h-8 text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-semibold text-white whitespace-nowrap">Office Wallet</h1>
          <p className="text-white/60 text-sm">Manage  and monitor team-wide spending power</p>
        </div>
      </div>
 
      {/* DASHBOARD STATS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-8">
        <StatCard
          title="Total Capital"
          value={summary?.wallet_total}
          icon={<Zap className="w-5 h-5" />}
          color="emerald"
          description="Total funds ever injected"
        />
        <StatCard
          title="System Outflow"
          value={summary?.total_spent}
          icon={<TrendingDown className="w-5 h-5" />}
          color="rose"
          description="Total validated expenses"
        />
        <StatCard
          title="Active Balance"
          value={summary?.remaining_balance}
          icon={<PieChart className="w-5 h-5" />}
          color="blue"
          description="Ready for allocation"
        />
      </div>
 




      <div className="lg:col-span-5 bg-white/5 border border-white/10 rounded-lg p-2 backdrop-blur-2xl shadow-2xl relative overflow-hidden mt-[-18px] mb-4">
           <div className="absolute -top-10 -right-10 w-32 h-32 bg-emerald-500/5 blur-3xl pointer-events-none mb-6" />
           
         
 

<div className="grid grid-cols-1 md:grid-cols-4 gap-2 md:gap-6 items-end">

  {/* AMOUNT */}
  <div className="space-y-1 group">
    {/* <label className="text-[10px] font-black uppercase text-white/30 tracking-widest ml-1">
Amount    </label> */}

    <div className="relative">
      {/* <IndianRupee className="absolute left-5 top-1/2 -translate-y-1/2 w-4 h-4 text-white/20 group-focus-within:text-emerald-400 transition" /> */}

      <input
        type="number"
        placeholder="Amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        className="w-full bg-white/5 border border-white/10 rounded-lg px-5 py-1.5 text-base  text-white outline-none focus:border-emerald-500/30 transition-all"
      />
    </div>
  </div>

  {/* NOTE */}
  <div className="space-y-2 group">
 

    <div className="relative">
      {/* <StickyNote className="absolute left-5 top-1/2 -translate-y-1/2 w-4 h-4 text-white/20 group-focus-within:text-white transition" /> */}

      <input
        placeholder="Remarks"
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        className="w-full bg-white/5 border border-white/10 rounded-lg px-5 py-1.5 text-base  text-white outline-none focus:border-emerald-500/30 transition-all"
      />
    </div>
  </div>

  {/* BUTTONS */}
  <div className="md:col-span-2 flex gap-4 ">

    <button
      onClick={() => { setAmount(""); setRemarks(""); }}
      className="flex-1 rounded-lg px-4   bg-white/5 border border-white/10 text-white/40    hover:text-white transition-all"
    >
      Reset
    </button>

    {/* <button
      onClick={handleAddAmount}
      className="flex-[2] py-2.5 rounded-lg bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-500 hover:to-teal-600 transition-all shadow-xl shadow-emerald-900/40 text-white font-black text-[11px] uppercase tracking-widest flex items-center justify-center gap-2"
    >
      <ShieldCheck className="w-4 h-4" />
      Submit
    </button> */}



<button
  onClick={handleAddAmount}
  disabled={isSubmitting}
  className={`
    flex-[2] py-2.5 rounded-lg
    bg-gradient-to-r from-emerald-600 to-teal-700
    transition-all shadow-xl text-white font-black text-[11px]
    flex items-center justify-center gap-2
    ${isSubmitting ? "opacity-60 cursor-not-allowed" : ""}
  `}
>
  {isSubmitting ? (
    <>
      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      Processing...
    </>
  ) : (
    <>
      <ShieldCheck className="w-4 h-4" />
      Submit
    </>
  )}
</button>

  </div>

</div>





        </div>




      {/* ACTION & HISTORY GRID */}
      {/* <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start w-full"> */}
      <div className="w-full">
        {/* ADD FUNDS FORM */}

 
        {/* HISTORY LIST */}
        {/* <div className="  lg:col-span-7 bg-white/5 border border-white/10 rounded-[40px] p-8 backdrop-blur-2xl shadow-2xl relative overflow-hidden flex flex-col min-h-[500px]"> */}
           
        <div id="expense-list-section" className="w-full bg-white/5 border border-white/10 rounded-[32px] p-6 backdrop-blur-2xl shadow-2xl">
           <div className="flex items-center justify-between mb-8">
             <div className="flex items-center gap-3">
               <div className="w-10 h-10 rounded-xl bg-blue-500/20 flex items-center justify-center border border-blue-500/10 text-blue-400">
                 <History className="w-5 h-5" />
               </div>
               <h3 className="text-xl font-semibold text-white whitespace-nowrap">Wallet History</h3>
             </div>
           </div>
 
           <div className="space-y-3 flex-1">
              {isLoading ? (
                <div className="py-20 flex flex-col items-center gap-4 opacity-30">
                  <div className="w-8 h-8 border-2 border-emerald-500 border-t-white rounded-full animate-spin" />
                  <span className="text-[10px] font-black uppercase tracking-[3px]">SYNCING LEDGER</span>
                </div>
              ) : history.length === 0 ? (
                <div className="py-20 flex flex-col items-center gap-4 opacity-10">
                  <RotateCcw className="w-12 h-12" />
                  <span className="text-[10px] font-black uppercase tracking-[3px]">NO TRANSACTION DATA</span>
                </div>
              ) : (
                <div className="w-full overflow-x-auto">
  <table className="w-full text-left border-collapse">
    
    {/* HEADER */}
    <thead>
      <tr className="text-white/40 text-xs uppercase tracking-widest border-b border-white/10">
        <th className="py-3 px-2">Amount</th>
        <th className="py-3 px-2">Remark </th>
        <th className="py-3 px-2">Date</th>
        <th className="text-right py-3 px-2">Action</th>
      </tr>
    </thead>

    {/* BODY */}
    <tbody>
      {history
        .slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
        .map((h) => (
        <tr
          key={h.id}
          className="border-b border-white/5 hover:bg-white/5 transition whitespace-nowrap"
        >
          <td className="py-4  text-white">
            ₹{Math.floor(Number(h.amount)).toLocaleString("en-IN")}
          </td>

          <td className="text-white/60 italic whitespace-nowrap px-2">
            {h.remarks || "Standard Injection"}
          </td>

          <td className="text-white/50 text-sm px-2">
            {formatDate(h.created_at)}
          </td>

          <td className="text-right">
            <button
              onClick={() => setConfirmDelete({ show: true, id: h.id })}
              className="p-2 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 hover:bg-red-600 hover:text-white transition"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
              )}
           </div>

           {/* PAGINATION */}
           {!isLoading && history.length > PAGE_SIZE && (
             <div className="flex items-center justify-between mt-4 pt-3 border-t border-white/10">
               <span className="text-xs text-white/40 font-bold">
                 {(currentPage - 1) * PAGE_SIZE + 1}–{Math.min(currentPage * PAGE_SIZE, history.length)} of {history.length}
               </span>
               <div className="flex items-center gap-2">
                 <button
                   onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                   disabled={currentPage === 1}
                   className="p-1.5 rounded-lg bg-white/5 border border-white/10 text-white/50 hover:bg-white/10 disabled:opacity-30 transition"
                 >
                   <ChevronLeft className="w-4 h-4" />
                 </button>
                 {Array.from({ length: Math.ceil(history.length / PAGE_SIZE) }, (_, i) => i + 1).map(pg => (
                   <button
                     key={pg}
                     onClick={() => setCurrentPage(pg)}
                     className={`w-7 h-7 rounded-lg text-xs font-bold transition ${
                       pg === currentPage
                         ? "bg-emerald-600 text-white"
                         : "bg-white/5 text-white/40 hover:bg-white/10"
                     }`}
                   >
                     {pg}
                   </button>
                 ))}
                 <button
                   onClick={() => setCurrentPage(p => Math.min(Math.ceil(history.length / PAGE_SIZE), p + 1))}
                   disabled={currentPage === Math.ceil(history.length / PAGE_SIZE)}
                   className="p-1.5 rounded-lg bg-white/5 border border-white/10 text-white/50 hover:bg-white/10 disabled:opacity-30 transition"
                 >
                   <ChevronRight className="w-4 h-4" />
                 </button>
               </div>
             </div>
           )}
        </div>
      </div>
 
      {/* DELETE MODAL PORTAL */}
      {confirmDelete.show && createPortal(
        <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
           <div className="absolute inset-0 bg-black/80 backdrop-blur-xl" onClick={() => setConfirmDelete({ show: false, id: null })} />
           <div className="relative w-full max-w-sm bg-gradient-to-br from-[#1e174a] to-[#0f0c29] rounded-[40px] p-10 text-center border border-white/20 shadow-2xl animate-scaleIn">
              <div className="w-20 h-20 bg-red-500/20 rounded-[28px] flex items-center justify-center mx-auto mb-6">
                <Trash2 className="w-10 h-10 text-red-500" />
              </div>
              <h3 className="text-2xl font-black text-white mb-2"> Delete this wallet entry?</h3>
              {/* <p className="text-sm font-medium text-white/40 mb-8 leading-relaxed">This injection will be reversed. Note: This may lead to negative active balance if spent.</p> */}
              <div className="flex flex-col gap-3">
                <button onClick={handleDeleteWallet} className="w-full py-4 rounded-2xl bg-red-600 text-white font-black text-xs uppercase tracking-widest hover:bg-red-700 transition shadow-xl shadow-red-900/40">
                  Delete
                </button>
                <button onClick={() => setConfirmDelete({ show: false, id: null })} className="w-full py-4 rounded-2xl bg-white/5 border border-white/10 text-white/60 font-black text-xs uppercase tracking-widest">
                  Cancel
                </button>
              </div>
           </div>
        </div>,
        document.body
      )}









{modal.show && createPortal(
  <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
    
    {/* BACKDROP */}
    <div
      className="absolute inset-0 bg-black/70 backdrop-blur-sm"
      onClick={() => setModal({ show: false, type: "", message: "" })}
    />

    {/* MODAL */}
    <div className="relative w-full max-w-sm bg-gradient-to-br from-[#1e174a] to-[#0f0c29] rounded-[30px] p-8 text-center border border-white/10 shadow-2xl">

      {/* ICON */}
      <div className={`w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-xl
        ${modal.type === "success" ? "bg-emerald-500/20" : "bg-red-500/20"}`}>
        
        {modal.type === "success" ? (
          <ShieldCheck className="w-8 h-8 text-emerald-400" />
        ) : (
          <X className="w-8 h-8 text-red-400" />
        )}
      </div>

      {/* MESSAGE */}
      <h3 className="text-white text-lg font-semibold mb-4">
        {modal.message}
      </h3>

      {/* BUTTON */}
      <button
        onClick={() => setModal({ show: false, type: "", message: "" })}
        className={`px-5 py-2 rounded-lg text-white font-medium
          ${modal.type === "success"
            ? "bg-emerald-600 hover:bg-emerald-700"
            : "bg-red-600 hover:bg-red-700"
          }`}
      >
        OK
      </button>

    </div>
  </div>,
  document.body
)}
    </div>
    </div>
  );
}
 
function StatCard({ title, value, icon, color, description }) {
  const colorMap = {
    emerald: "from-emerald-400 to-teal-500 bg-emerald-500/10 text-emerald-400 shadow-emerald-900/20",
    rose: "from-rose-400 to-pink-500 bg-rose-500/10 text-rose-400 shadow-rose-900/20",
    blue: "from-blue-400 to-indigo-500 bg-blue-500/10 text-blue-400 shadow-blue-900/20",
  };
 
  return (



    //     <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
//       <p className="text-white/60 text-xs">{title}</p>
//       <p className={`text-2xl font-bold ${colorMap[color]}`}>
//         {/* ₹ {value} */}
//         ₹ {Number(value).toFixed(0)}
//       </p>
//     </div>
    <div className="bg-white/5 border border-white/10 rounded-lg p-4 backdrop-blur-3xl shadow-2xl text-center relative overflow-hidden group hover:bg-white/[0.08] transition-all duration-500">
      <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br ${colorMap[color]} opacity-5 blur-2xl group-hover:opacity-10 transition-opacity`} />
      <div className="flex justify-center items-center mb-6">
        {/* <div className={`p-4 rounded-2xl ${colorMap[color].split(' ')[2]} ${colorMap[color].split(' ')[3]} border ${colorMap[color].split(' ')[3].replace('text', 'border')}/10`}>
          {icon}
        </div> */}
        <div className="text-center">
          <p className="text-xs text-white/50">{title}</p>
          <div className="flex items-center justify-end gap-1 text-white">
            <span className="text-sm font-bold opacity-30">₹</span>
            <h4 className="text-2xl font-semibold tracking-tighter">
              {/* {Number(value || 0).toLocaleString()} */}
              {Number(value || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 0,
  })}
              </h4>
          </div>
        </div>
      </div>
      {/* <p className="text-[10px] font-bold text-white/20 uppercase tracking-widest leading-none bg-black/20 inline-block px-3 py-1.5 rounded-full">{description}</p> */}
    </div>
  );
}
 





// import { useEffect, useState } from "react";
// import {
//   addOfficeWalletApi,
//   getOfficeWalletHistoryApi,
//   getOfficeExpenseSummaryApi,
//   deleteOfficeWalletApi,
// } from "../../app/api";

// export default function Wallet() {
//   const [amount, setAmount] = useState("");
//   const [remarks, setRemarks] = useState("");
//   const [history, setHistory] = useState([]);
//   const [summary, setSummary] = useState(null);

//   const [confirmDelete, setConfirmDelete] = useState({
//     show: false,
//     id: null,
//   });

//   useEffect(() => {
//     loadWalletData();
//   }, []);

//   const loadWalletData = async () => {
//     const r1 = await getOfficeWalletHistoryApi();
//     if (r1.success) setHistory(r1.data || []);

//     const r2 = await getOfficeExpenseSummaryApi();
//     if (r2.success) setSummary(r2.data || null);
//   };

//   // const loadWalletData = async () => {
//   //   const r1 = await getOfficeWalletHistoryApi();
  
//   //   if (r1.success) {
//   //     const cleanedHistory = r1.data.map((h) => ({
//   //       ...h,
//   //       amount: Math.floor(Number(h.amount) || 0),
//   //     }));
  
//   //     setHistory(cleanedHistory);
//   //   }
  
//   //   const r2 = await getOfficeExpenseSummaryApi();
  
//   //   if (r2.success) {
//   //     // setSummary({
//   //     //   wallet_total: Math.floor(Number(r2.data.wallet_total) || 0),
//   //     //   total_spent: Math.floor(Number(r2.data.total_spent) || 0),
//   //     //   remaining_balance: Math.floor(Number(r2.data.remaining_balance) || 0),
//   //     // });


//   //     setSummary({
//   //       wallet_total: Math.round(Number(r2.data.wallet_total) || 0),
//   //       total_spent: Math.round(Number(r2.data.total_spent) || 0),
//   //       remaining_balance: Math.round(Number(r2.data.remaining_balance) || 0),
//   //     });
//   //   }
//   // };


//   const handleAddAmount = async () => {
//     if (!amount) return alert("Enter amount");

//     const res = await addOfficeWalletApi({
//       amount: Number(amount),
//       remarks,
//     });

//     if (res.success) {
//       setAmount("");
//       setRemarks("");
//       loadWalletData();
//     } else {
//       alert("Failed");
//     }
//   };

//   const handleDeleteWallet = async () => {
//     const res = await deleteOfficeWalletApi(confirmDelete.id);
//     if (res.success) loadWalletData();
//     setConfirmDelete({ show: false, id: null });
//   };

//   return (
//     <div
//       className="
//       rounded-2xl
//       p-6
//       md:mt-20
//       bg-gradient-to-br
//       from-[#2d1c6a]
//       via-[#24155a]
//       to-[#12082f]
//       text-white
//       border border-white/10
//       shadow-2xl shadow-[#12082F]/60
//       relative
//     "
//     >
//       {/* glow */}
//       <div className="absolute -top-10 -right-10 w-60 h-60 bg-purple-500/20 blur-3xl rounded-full" />
//       <div className="absolute bottom-0 -left-10 w-60 h-60 bg-fuchsia-500/20 blur-3xl rounded-full" />

//       <div className="relative z-10">
//         <h3 className="font-bold  text-2xl mb-5">Office Wallet</h3>

//         {/* SUMMARY */}
//         {summary && (
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
//             <Stat title="Total Wallet" value={summary.wallet_total} color="green" />
//             <Stat title="Total Spent" value={summary.total_spent} color="red" />
//             <Stat title="Remaining" value={summary.remaining_balance} color="blue" />
//           </div>
//         )}

//         {/* ADD WALLET */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6">
//           <Input
//             type="number"
//             placeholder="Amount"
//             value={amount}
//             onChange={(e) => setAmount(e.target.value)}
//           />
//           <Input
//             placeholder="Remarks"
//             value={remarks}
//             onChange={(e) => setRemarks(e.target.value)}
//           />

//           <button
//             onClick={() => {
//               setAmount("");
//               setRemarks("");
//             }}
//             className="bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg py-1.5"
//           >
//             Reset
//           </button>

//           <button
//             onClick={handleAddAmount}
//             className="bg-purple-600 hover:bg-purple-500 rounded-lg shadow py-1.5"
//           >
//             Submit
//           </button>
//         </div>

//         {/* HISTORY */}
//         <h4 className="font-medium mb-3">Wallet History</h4>

//         <div className="max-h-[360px] overflow-y-auto">
//           <table className="w-full text-sm">
//             <thead className="text-white/70 border-b border-white/10">
//               <tr>
//                 <th className="whitespace-nowrap px-3 py-2 text-left">Amount</th>
//                 <th className="whitespace-nowrap px-3 py-2 text-left">Remarks</th>
//                 <th className="whitespace-nowrap px-3 py-2 text-left">Date</th>
//                 <th className="whitespace-nowrap px-3 py-2 text-left">Delete</th>
//               </tr>
//             </thead>

//             <tbody>
//               {history.length > 0 ? (
//                 history.map((h) => (
//                   <tr
//                     key={h.id}
//                     className="border-b border-white/5 hover:bg-white/5 transition"
//                   >
//                     <td className="whitespace-nowrap px-3 py-2 text-left">₹ {h.amount}</td>
//                     <td  className="whitespace-nowrap px-3 py-2 text-left">{h.remarks}</td>
//                     <td className="whitespace-nowrap px-3 py-2 text-left">
//                       {h.created_at
//                         ? new Date(h.created_at).toLocaleDateString()
//                         : "-"}
//                     </td>
//                     <td className="whitespace-nowrap px-3 py-2 text-left">
//                       <button
//                         onClick={() =>
//                           setConfirmDelete({ show: true, id: h.id })
//                         }
//                         className="
//                           px-3 py-1 rounded-full
//                           bg-red-500/20 text-red-300
//                           hover:bg-red-500 hover:text-white
//                           transition text-xs
//                         "
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4" className="py-6 text-center opacity-60">
//                     No wallet history
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* DELETE MODAL */}
//       {confirmDelete.show && (
//         <div className="absolute inset-0 bg-black/70 flex items-center justify-center z-20">
//           <div className="bg-[#1c1045] border border-red-400/30 rounded-xl p-6 text-center">
//             <p className="mb-4">Delete this wallet entry?</p>
//             <div className="flex gap-4 justify-center">
//               <button
//                 onClick={() => setConfirmDelete({ show: false })}
//                 className="px-4 py-1 rounded bg-white/10"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeleteWallet}
//                 className="px-4 py-1 rounded bg-red-600 text-white"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* ---------------- UI helpers ---------------- */

// function Input(props) {
//   return (
//     <input
//       {...props}
//       className="
//         bg-white/10 border border-white/20
//         rounded-lg px-3 py-2 text-sm
//         focus:outline-none focus:ring-2 focus:ring-purple-500/40
//       "
//     />
//   );
// }

// function Stat({ title, value, color }) {
//   const colorMap = {
//     green: "text-green-400",
//     red: "text-red-400",
//     blue: "text-blue-400",
//   };

//   return (
//     <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
//       <p className="text-white/60 text-xs">{title}</p>
//       <p className={`text-2xl font-bold ${colorMap[color]}`}>
//         {/* ₹ {value} */}
//         ₹ {Number(value).toFixed(0)}
//       </p>
//     </div>
//   );
// }





// import { useEffect, useState } from "react";
// import {
//   addOfficeWalletApi,
//   getOfficeWalletHistoryApi,
//   getOfficeExpenseSummaryApi,
//   deleteOfficeWalletApi,
// } from "../../app/api";

// export default function Wallet() {
//   const [amount, setAmount] = useState("");
//   const [remarks, setRemarks] = useState("");
//   const [history, setHistory] = useState([]);
//   const [summary, setSummary] = useState(null);

//   const [confirmDelete, setConfirmDelete] = useState({
//     show: false,
//     id: null,
//   });

//   useEffect(() => {
//     loadWalletData();
//   }, []);

//   const loadWalletData = async () => {
//     const r1 = await getOfficeWalletHistoryApi();
//     if (r1.success) setHistory(r1.data || []);

//     const r2 = await getOfficeExpenseSummaryApi();
//     if (r2.success) setSummary(r2.data || null);
//   };

//   const handleAddAmount = async () => {
//     if (!amount) return alert("Enter amount");

//     const res = await addOfficeWalletApi({
//       amount: Number(amount),
//       remarks,
//     });

//     if (res.success) {
//       setAmount("");
//       setRemarks("");
//       loadWalletData();
//     } else {
//       alert("Failed");
//     }
//   };

//   const handleDeleteWallet = async () => {
//     const res = await deleteOfficeWalletApi(confirmDelete.id);
//     if (res.success) loadWalletData();
//     setConfirmDelete({ show: false, id: null });
//   };

//   return (
//     <div
//       className="
//       rounded-2xl
//       p-6
//       md:mt-20
//       bg-gradient-to-br
//       from-[#2d1c6a]
//       via-[#24155a]
//       to-[#12082f]
//       text-white
//       border border-white/10
//       shadow-2xl shadow-[#12082F]/60
//       relative
//     "
//     >
//       {/* glow */}
//       <div className="absolute -top-10 -right-10 w-60 h-60 bg-purple-500/20 blur-3xl rounded-full" />
//       <div className="absolute bottom-0 -left-10 w-60 h-60 bg-fuchsia-500/20 blur-3xl rounded-full" />

//       <div className="relative z-10">
//         <h3 className="font-bold  text-2xl mb-5">Office Wallet</h3>

        // {/* SUMMARY */}
        // {summary && (
        //   <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        //     <Stat title="Total Wallet" value={summary.wallet_total} color="green" />
        //     <Stat title="Total Spent" value={summary.total_spent} color="red" />
        //     <Stat title="Remaining" value={summary.remaining_balance} color="blue" />
        //   </div>
        // )}

        // {/* ADD WALLET */}
        // <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6">
        //   <Input
        //     type="number"
        //     placeholder="Amount"
        //     value={amount}
        //     onChange={(e) => setAmount(e.target.value)}
        //   />
        //   <Input
        //     placeholder="Remarks"
        //     value={remarks}
        //     onChange={(e) => setRemarks(e.target.value)}
        //   />

        //   <button
        //     onClick={() => {
        //       setAmount("");
        //       setRemarks("");
        //     }}
        //     className="bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg py-1.5"
        //   >
        //     Reset
        //   </button>

        //   <button
        //     onClick={handleAddAmount}
        //     className="bg-purple-600 hover:bg-purple-500 rounded-lg shadow py-1.5"
        //   >
        //     Submit
        //   </button>
        // </div>

//         {/* HISTORY */}
//         <h4 className="font-medium mb-3">Wallet History</h4>

//         <div className="max-h-[360px] overflow-y-auto">
//           <table className="w-full text-sm">
//             <thead className="text-white/70 border-b border-white/10">
//               <tr>
//                 <th className="whitespace-nowrap px-3 py-2 text-left">Amount</th>
//                 <th className="whitespace-nowrap px-3 py-2 text-left">Remarks</th>
//                 <th className="whitespace-nowrap px-3 py-2 text-left">Date</th>
//                 <th className="whitespace-nowrap px-3 py-2 text-left">Delete</th>
//               </tr>
//             </thead>

//             <tbody>
//               {history.length > 0 ? (
//                 history.map((h) => (
//                   <tr
//                     key={h.id}
//                     className="border-b border-white/5 hover:bg-white/5 transition"
//                   >
//                     <td className="whitespace-nowrap px-3 py-2 text-left">₹ {h.amount}</td>
//                     <td  className="whitespace-nowrap px-3 py-2 text-left">{h.remarks}</td>
//                     <td className="whitespace-nowrap px-3 py-2 text-left">
//                       {h.created_at
//                         ? new Date(h.created_at).toLocaleDateString()
//                         : "-"}
//                     </td>
//                     <td className="whitespace-nowrap px-3 py-2 text-left">
//                       <button
//                         onClick={() =>
//                           setConfirmDelete({ show: true, id: h.id })
//                         }
//                         className="
//                           px-3 py-1 rounded-full
//                           bg-red-500/20 text-red-300
//                           hover:bg-red-500 hover:text-white
//                           transition text-xs
//                         "
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4" className="py-6 text-center opacity-60">
//                     No wallet history
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* DELETE MODAL */}
//       {confirmDelete.show && (
//         <div className="absolute inset-0 bg-black/70 flex items-center justify-center z-20">
//           <div className="bg-[#1c1045] border border-red-400/30 rounded-xl p-6 text-center">
//             <p className="mb-4">Delete this wallet entry?</p>
//             <div className="flex gap-4 justify-center">
//               <button
//                 onClick={() => setConfirmDelete({ show: false })}
//                 className="px-4 py-1 rounded bg-white/10"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeleteWallet}
//                 className="px-4 py-1 rounded bg-red-600 text-white"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* ---------------- UI helpers ---------------- */

// function Input(props) {
//   return (
//     <input
//       {...props}
//       className="
//         bg-white/10 border border-white/20
//         rounded-lg px-3 py-2 text-sm
//         focus:outline-none focus:ring-2 focus:ring-purple-500/40
//       "
//     />
//   );
// }

// function Stat({ title, value, color }) {
//   const colorMap = {
//     green: "text-green-400",
//     red: "text-red-400",
//     blue: "text-blue-400",
//   };

//   return (
//     <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
//       <p className="text-white/60 text-xs">{title}</p>
//       <p className={`text-2xl font-bold ${colorMap[color]}`}>
//         ₹ {value}
//       </p>
//     </div>
//   );
// }
